var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgESignalRoomControlSignalCommunicativeCooling = function SvgESignalRoomControlSignalCommunicativeCooling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 178,
    width: 2,
    height: 80,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 178,
    width: 2,
    height: 219,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220 70 400 70 400 162 402 162 402 68 218 68 218 162 220 162 220 70",
    fill: "#1c9d5b"
  })))));
};
export default SvgESignalRoomControlSignalCommunicativeCooling;